import React from "react";

function ProductSelector({
  brandOptions,
  productOptions,
  selectedBrand,
  selectedProduct,
  setSelectedBrand,
  setSelectedProduct,
  handleAddProduct,
}) {
  return (
    <div className="card shadow-sm border-0">

      <div className="custom-modal-header text-white">
        <h5 className="mb-0">Add Product</h5>
      </div>

      <div className="card-body">
        <div className="row">

          {/* BRAND */}
          <div className="col-md-5">
            <label className="form-label">Brand</label>
            <select
              className="form-control custumform"
              value={selectedBrand?.value || ""}
              onChange={(e) => {
                const found = brandOptions.find(
                  (b) => String(b.value) === String(e.target.value)
                );
                setSelectedBrand(found || null);
              }}
            >
              <option value="">Select Brand</option>
              {brandOptions?.map((brand) => (
                <option key={brand.value} value={brand.value}>
                  {brand.label}
                </option>
              ))}
            </select>
          </div>

          {/* PRODUCT */}
          <div className="col-md-5">
            <label className="form-label">Product</label>
            <select
              className="form-control custumform"
              value={selectedProduct?.value || ""}
              onChange={(e) => {
                const found = productOptions.find(
                  (p) => String(p.value) === String(e.target.value)
                );
                setSelectedProduct(found || null);
              }}
              disabled={!selectedBrand}
            >
              <option value="">Select Product</option>
              {productOptions?.map((product) => (
                <option key={product.value} value={product.value}>
                  {product.label}
                </option>
              ))}
            </select>
          </div>

          {/* ADD BUTTON */}
          <div className="col-md-2 d-grid">
            <label className="form-label text-white">.</label>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleAddProduct}
            >
              + Add
            </button>
          </div>

        </div>
      </div>

    </div>
  );
}

export default ProductSelector;